import { Outlet } from 'react-router-dom';

export default function BoardLayout() {
  // Only render whatever the current child route is:
  // - index → <ProfileBoard/>
  // - post/:id → <Post/>
  // - article/:id → <ArticleWrapper/>
  return <Outlet />;
}
